import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InwardStatus } from 'src/app/Enums/inwardEnum';
import { AuditData } from 'src/app/shared/classes/AuditTrail';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { InwardService } from 'src/app/shared/services/inward.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';

@Component({
  selector: 'app-received-by',
  templateUrl: './received-by.component.html',
  styleUrls: ['./received-by.component.less']
})
export class ReceivedByComponent implements OnInit {
  selectedRequest : any;
  viewData : any;
  InwardStatus : InwardStatus;
  name: string = '';
  private service_URL: any;
  private unsubscribe$ =new Subject<void>();

  constructor(
    private modalService: BsModalService,
    private _dataContextService: DataContextService,
    private toast: ToastrService,
    private trackeromnitureservice:TrackerOmnitureService
  ) {
    this.service_URL = ConstantsService;
   }

  ngOnInit(): void {
    var username = localStorage.getItem('email');
    username = username.split('@')[0];
    this.trackeromnitureservice.trackPageloadData('received-by',username);
    this.trackeromnitureservice.trackPage("pageView");

    // console.log(this.selectedRequest);
    this.GetById(this.selectedRequest.requestId);
  }

  GetById(id){
    this._dataContextService.get<any>(this.service_URL.InwardDetails.ViewRequest + '/' + id)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((res) => {
      // console.log(res);
      this.selectedRequest = res;
      },
      (error) => {
        console.log(error);
        this.toast.error("Something not working");
      },
      () => {
        // console.log(this.selectedRequest);
      }
    )
  }

  Cancel(){
    this.modalService.hide(1);
    $('body').removeClass('modal-open');
  }

  UpdateStatus(){
    let params = {
      statusId : InwardStatus.Received,
      requestId : this.selectedRequest.requestId,
      updatedBy: localStorage.getItem('email')
    }

    let auditData = [];

    let statusChangeAudit: AuditData = new AuditData();
    statusChangeAudit.changedAttribute = "Status";
    statusChangeAudit.oldValue = "Challan Uploaded";
    statusChangeAudit.newValue = "Received";

    auditData.push(statusChangeAudit);
    
    this._dataContextService.postDatawithValues<any>(this.service_URL.InwardDetails.UpdateStatus,params)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((res) => {
      if(res == 1){
        // this.modalService.hide(1);
      }
      else{
        this.toast.error("Something went wrong");
      }
    },
    (error)=>{
      this.toast.error("Status cannot be updated");
    },
    () => {
      //Saving Data in Audit Trail
      let auditParams = {
        actionPerformed : "Status Change",
        actionPerformedOn : "Inward",
        changedBy : localStorage.getItem('email'),
        dateChanged : new Date(),
        primaryKey : this.selectedRequest.serialNumber,
        generalInformation : [],
        material : [],
        statusChange: auditData
      };

        this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.savetransactionaudittrail,auditParams)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res) => {
          // console.log(res);
        },
        (err) => {
          console.log(err);
        },
        () => {
          this.modalService.hide(1);
          window.location.reload();
        })
    })
  }

  Submit(){

    let PrepareObj = {
      RequestId: this.selectedRequest.requestId,
      DCNumber : this.selectedRequest.dcNumber,
      RegistrationDateTime : this.selectedRequest.registrationDateTime,
      ReturnDateTime : this.selectedRequest.returnDateTime,
      Remarks : this.selectedRequest.remarks,
      // BroughtFromId : this.selectedOption === undefined ? 0 : this.selectedOption.broughtFromId,
      BroughtFromId : parseInt(this.selectedRequest.broughtFrom),
      ReceivedById : parseInt(this.selectedRequest.receivedBy),
      // BroughtFromName : this.selectedOption === undefined ? this.nameNotInList : this.selectedOption.name,
      // BroughtFrom : this.selectedOption === undefined ? this.nameNotInList : this.selectedOption.name,
      BroughtFromName : this.selectedRequest.broughtFromName,
      BroughtFrom : this.selectedRequest.broughtFromName,
      ReceivedBy : this.name.toUpperCase(),
      ReceivedByName : this.name.toUpperCase(),
      ReceivedOn : new Date().toISOString(),
      RegistrationType : this.selectedRequest.registrationType,
      IsActive : this.selectedRequest.isActive,
      StatusId : this.selectedRequest.statusId,
      CreatedBy: this.selectedRequest.createdBy,
      UpdatedBy: localStorage.getItem('email'),
      materialList : this.selectedRequest.materialList,
      attachedFiles:[]
    }

    // console.log(PrepareObj);
    
    let params = {
        receivedById: this.selectedRequest.receivedById,
        receivedByName: this.name.toUpperCase(),
        updatedBy: localStorage.getItem('email')
    };

    this._dataContextService.postDatawithValues<any>(this.service_URL.InwardDetails.UpdateInwardRequest, PrepareObj)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((res) => {
      if(res == 1){
        this.UpdateStatus();
        // this.toast.success("Updated Received By");
      }
      else{
        this.toast.error("Something went wrong");
      }
    },
    (error)=>{
      this.toast.error("Received By cannot be updated");
    },
    () => {
      this.toast.success("Received By Added");
    }) 
    
    
}
}
